// eslint-disable-next-line import/prefer-default-export
export var BORDER_WIDTH = 2;